import { createApp } from 'vue';
import { plugin, defaultConfig } from '@formkit/vue';
import "@formkit/themes/genesis";
import '@formkit/pro/genesis'
import { createProPlugin, inputs } from '@formkit/pro'
import App from '@/App.vue';
import router from '@/router';
import store  from './store/index.js';

//import VuePluralize from 'vue-pluralize'

import 'bootstrap/dist/css/bootstrap.min.css';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.js";

import './assets/css/style.css';

import { FontAwesomeIcon } from '@/plugins/font-awesome';

//import {eposAxios, epos2Axios} from "@/http-common";

import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';

import Select2 from 'vue3-select2-component';
import 'select2/dist/css/select2.min.css';

//import cookie
import VueCookies from 'vue-cookies';

const eposApp = createApp(App)
const pro = createProPlugin('fk-27d34336a72', inputs)

//Assign the global variable before mounting
eposApp.provide(
    /* key */ 'globalColoursOptions',
    /* value */ [
            { label: 'Red', value: '255,0,0' },
            { label: 'Orange', value: '255,153,0' },
            { label: 'Yellow', value: '255,255,0' },
            { label: 'Green', value: '0,255,0' },
            { label: 'Blue', value: '0,0,255' },
            { label: 'Purple', value: '153,0,255' },
            { label: 'Black', value: '0,0,0' },
            { label: 'Magenta', value: '255,0,255' },
            { label: 'Cyan', value: '0,255,255' },
    ]
)
eposApp.provide(
    'servicesWithoutPiecingUp',
    [
        3, // Laundry
        9, // Shoe Repair
        72, // Return only
        86 // Replacement
    ]
)
eposApp.provide(
    'servicesExceptions',
    [
        3, // Laundry
        72 // Return only
    ]
)
eposApp.provide('barcodePatterns', 
    {
    'garment'       : /^G(\d+)$/,
    'customer'      : /^C(\d+)$/,
    'item'          : /^I(\d+)$/,
    'order'         : /^O(\d{3,})$/,
    'order-id'      : /^(\d{3,})$/,
    'ticket'        : /^ST(\d{9,})\/(\w{8,})$/, // Valid for types 2: ST000787166/ecc3d838
    'ticket_order'  : /^ST(\d{9,})\/(\d{2})$/, // Valid for types 1: ST000787163/03
    'rail'          : /^R(\d{4})$/,             // Dispatch Rails, in the loading bay
    'qc-status'     : /^QCS(\d{1,})$/,
    'qc-rail'       : /^QCR(\d{1,})$/,
    'pu-rail'       : /^PUR(\d{4})$/,
    'command'       : /^LRCMD:(.*)$/
    }
  )

eposApp.provide( 'test_environment',process.env.VUE_APP_TEST_ENV)
eposApp.provide("sessionUser", {})

eposApp.use(router)
eposApp.use(store)
eposApp.use(plugin,
    defaultConfig({
        messages: {
            en: {
                validation: {
                    required({ name }) {
                        return `Please fill out the ${name} field.`
                    }
                }
            }
        },
        theme: 'genesis', // will load from CDN and inject into document head
        plugins: [pro],
        })
)
eposApp.use(bootstrap)
//eposApp.use(VuePluralize)
eposApp.use(VueCookies, { expires: '2h'})
//eposApp.use(VueCookies, { expires: '10s'})
eposApp.component("font-awesome-icon", FontAwesomeIcon)
eposApp.component('EasyDataTable', Vue3EasyDataTable)
eposApp.component('Select2Select', Select2)

// Register a global custom directive called `v-focus`
eposApp.directive('focus', {
    // When the bound element is mounted into the DOM...
    mounted(el) {
        // Focus the element
        el.focus()
    }
})
eposApp.mount('#app')
